import type { ConfigLoader } from "@amzn/amazon-config-store-type-script-offline-adapter";
import {
    ClientStage,
    OfflineClientSettings,
    OfflineConfigManager,
} from "@amzn/amazon-config-store-type-script-offline-adapter";
import CountryCodeToMarketplaceIdProdDocuments from "@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_CountryCodeToMarketplaceIdMap/documents.json";
import CountryCodeToMarketplaceIdProdHfQueries from "@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_CountryCodeToMarketplaceIdMap/hierarchical_queries.json";
import CountryCodeToMarketplaceIdProdExactQueries from "@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/acs_CountryCodeToMarketplaceIdMap/queries.json";
import CountryCodeToMarketplaceIdDevoDocuments from "@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_CountryCodeToMarketplaceIdMap/documents.json";
import CountryCodeToMarketplaceIdDevoHfQueries from "@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_CountryCodeToMarketplaceIdMap/hierarchical_queries.json";
import CountryCodeToMarketplaceIdDevoExactQueries from "@amzn/amazon-config-store-type-script-offline-adapter/dist/configuration/devo/acs_CountryCodeToMarketplaceIdMap/queries.json";
import { decryptCustomerId } from "@amzn/amazon-id";
import {
    CountryCodeToMarketplaceIdMapClientProvider,
    CountryCodeToMarketplaceIdMapContext,
} from "@amzn/country-code-to-marketplace-id-map-type-script-client/dist/countryCodeToMarketplaceIdMap";
import type { CountryCodeToMarketplaceIdMapClient } from "@amzn/country-code-to-marketplace-id-map-type-script-client/dist/countryCodeToMarketplaceIdMap";

import { getAuthSettings } from "../api/websiteSettings";

const isProd = (stage: string) => stage === "prod";
const CX_FAMILY = "retail";

const countryCodeToMarketplaceIdProdConfig: ConfigLoader = {
    load: () => ({
        documents: CountryCodeToMarketplaceIdProdDocuments.documents,
        exactQueries: CountryCodeToMarketplaceIdProdExactQueries.queries,
        hierarchicalFallbackQueries:
            CountryCodeToMarketplaceIdProdHfQueries.queries,
    }),
};

const countryCodeToMarketplaceIdDevoConfig: ConfigLoader = {
    load: () => ({
        documents: CountryCodeToMarketplaceIdDevoDocuments.documents,
        exactQueries: CountryCodeToMarketplaceIdDevoExactQueries.queries,
        hierarchicalFallbackQueries:
            CountryCodeToMarketplaceIdDevoHfQueries.queries,
    }),
};

const configManager = new OfflineConfigManager();

export const getCountryCodeToMarketplaceIdClient = (
    stage: string,
): CountryCodeToMarketplaceIdMapClient => {
    return configManager.createClient(
        new CountryCodeToMarketplaceIdMapClientProvider(),
        isProd(stage)
            ? countryCodeToMarketplaceIdProdConfig
            : countryCodeToMarketplaceIdDevoConfig,
        new OfflineClientSettings({
            stage: isProd(stage) ? ClientStage.PROD : ClientStage.DEVO,
        }),
    );
};

export const getMarketplaceIdFromCountryCode = (
    countryCode: string,
): string => {
    const { stage } = getAuthSettings();
    const obfuscatedMarketplaceId =
        getCountryCodeToMarketplaceIdClient(stage).getObfuscatedMarketplaceId(
            new CountryCodeToMarketplaceIdMapContext(CX_FAMILY, countryCode),
        ) || "";
    if (!obfuscatedMarketplaceId) {
        return "";
    }
    return decryptCustomerId(obfuscatedMarketplaceId).toString();
};
